import { Component, Input } from '@angular/core';

export type AnalyticsIconType = 'source' | 'browser' | 'device' | 'os';

@Component({
  selector: 'app-analytics-icon',
  templateUrl: './analytics-icon.component.html',
})
export class AnalyticsIconComponent {
  @Input() name: string = '';
  @Input() type: AnalyticsIconType = 'source';
  @Input() size: number = 16;
  @Input() className: string = '';
  imgError: boolean = false;

  get lucideIcon(): string | null {
    const n = this.name?.toLowerCase() || '';

    if (this.type === 'source') {
      if (n.includes('google')) return 'search';
      if (n.includes('facebook') || n.includes('fb')) return 'share-2';
      if (n.includes('twitter') || n.includes('x.com')) return 'share-2';
      if (n.includes('instagram')) return 'share-2';
      if (n.includes('linkedin')) return 'share-2';
      if (n.includes('youtube')) return 'play-circle';
      if (n === 'direct') return 'navigation';
      return 'link';
    }

    if (this.type === 'device') {
      if (n === 'mobile') return 'smartphone';
      if (n === 'tablet') return 'tablet';
      if (n === 'laptop' || n === 'desktop') return 'monitor';
      return 'monitor';
    }

    if (this.type === 'browser') {
      return 'globe';
    }

    if (this.type === 'os') {
      return 'cpu';
    }

    return null;
  }

  get imagePath(): string | null {
    const n = this.name?.toLowerCase()?.replace(/\s+/g, '') || '';
    if (!n) return null;

    if (this.type === 'browser') {
      return `assets/images/browser/${n}.svg`;
    }
    if (this.type === 'device') {
      return `assets/images/device/${n}.svg`;
    }
    if (this.type === 'os') {
      return `assets/images/operating-system/${n}.svg`;
    }

    return null;
  }
}
